<div
  *ngIf="profile"
  class="profile-item"
  fxLayoutAlign="space-between center"
  (click)="selectProfile(profile)"
>
  <div fxLayoutAlign="start center">
    <div class="img-wrapper mr-25">
      <img src="assets/images/profile/profile_select.svg" alt="icon" />
    </div>
    <p>{{ profile.clientName }}</p>
  </div>
  <img
    *ngIf="currentProfile && +currentProfile === profile.clientId"
    src="/assets/images/page-link/item_selected.svg"
    alt="arrow"
  />
</div>